require('./brokerStocksSaleOrderStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('commonsComponents/OKTooltip');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_STOCKS_SALE_ORDER_SIGNATURE_PATTERN_PARAM,
    SECOND_STEP,
    BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE,
    BROKER_PRODUCT_TYPE_OPA
} = require('constants/index');
const CLASS_NAME = 'broker-stocks-sale-order-step2';

const BrokerStocksSaleOrderStep2 = props => {
    const { immBrokerStocksSaleOrder, actions, onChangeManifest, cancelButton, nextButton, setDocumentsRead } = props;
    const secondStep = immBrokerStocksSaleOrder.getIn(['steps', SECOND_STEP]);
    const secondStepLoading = secondStep.get('loading');
    const manifest = secondStep.get('acceptedManifest');
    const manifestNotChecked = secondStep.getIn(['errorFlags', 'manifestNotChecked']);
    const product = immBrokerStocksSaleOrder.getIn(['contract', 'product']);
    const contractNumber = immBrokerStocksSaleOrder.getIn(['contract', 'number']);
    const signaturePatternParams = {
        chargeAccount: `${BROKER_STOCKS_SALE_ORDER_SIGNATURE_PATTERN_PARAM}${product}${contractNumber}`
    };
    const isin = immBrokerStocksSaleOrder.getIn(['operation', 'isin'])
    const iso = immBrokerStocksSaleOrder.getIn(['operation', 'iso'])
    const showWarning = secondStep.get('showWarning')
    const productDefinition = immBrokerStocksSaleOrder.getIn(['operation', 'descriptionValue'])

    const showSignaturePattern = () => {
        setDocumentsRead();
    }

    let documentsNotRead = null;
    if (showWarning) {
        documentsNotRead = (
            <div className={`${CLASS_NAME}__warning-message`}>
                <OKMessage type="warning">
                    <FormattedText value="brokerLegalDocumentation-documentsRead" />
                </OKMessage>
            </div>
        )
    }

    let signaturePattern = null;
    if (secondStep.get('acceptedManifest')) {
        signaturePattern = (
            <div className={`${CLASS_NAME}__signature-pattern`}>
                <SignaturePattern
                    operationType={BROKER_REQUEST_FINANCIAL_OPERATION_CHANGE_SIGNATURE_PATTERN_OPERATION_TYPE}
                    operationParams={signaturePatternParams}
                />
            </div>
        )
    }

    return (
        <WizardStep
            actions={actions}
            cancelButton={cancelButton}
            finishButton={nextButton}
            immFinalButton="stocksSaleOrder-emit"
            position="last"
            isLoading={secondStepLoading}
            addLoadingBehaviour={nextButton}
        >
            <h4 className={`${CLASS_NAME}__header-title`}>
                <FormattedText value="stocksSaleOrder-orderConfirmation"/>
            </h4>
            <div className={`${CLASS_NAME}__info`}>
                <FormattedText value="stocksSaleOrder-verifyInformation"/>
            </div>
            <BrokerLegalDocumentation
                isin={isin}
                iso={iso}
                productDefinition={productDefinition}
                productType={BROKER_PRODUCT_TYPE_OPA}
                reportCompleted={() => showSignaturePattern()}
            />
            {documentsNotRead}
            <OKTooltip
                content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                offset={[-50, -5]}
                placement={'topLeft'}
                target={
                    <div className={`${CLASS_NAME}__disclaimer`}>
                        <OKCheckbox
                            idName="manifest"
                            label={formatText('stocksSaleOrder-manifest')}
                            value={manifest}
                            onChange={onChangeManifest}
                            errorState={manifestNotChecked}
                            errorMessage={formatText('requestFinancialOperationChange-checkError')}
                        />
                    </div>
                } />
            {signaturePattern}
        </WizardStep>
    );
};

BrokerStocksSaleOrderStep2.propTypes = {
    immBrokerStocksSaleOrder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool,
    setDocumentsRead: PropTypes.func.isRequired
};

BrokerStocksSaleOrderStep2.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerStocksSaleOrderStep2;
